import { createAsyncThunk } from '@reduxjs/toolkit';
import httpService from './httpService';
export const getFamily: any = createAsyncThunk<any>(
	'getFamily',
	async (data) => {
		const response = await httpService.get(`productService/category`, {
			params: data
		});
		return response.data;
	}
);
export const getCategoryData: any = createAsyncThunk<any>(
	'getCategoryData',
	async (data) => {
		const response = await httpService.get(`productService/category`, {
			params: data
		});
		return response.data;
	}
);
export const getParentCategory: any = createAsyncThunk<any>(
	'getParentCategory',
	async (data) => {
		const response = await httpService.get(`productService/category`, {
			params: data
		});
		return response.data;
	}
);
export const getSubCategory: any = createAsyncThunk<any>(
	'getSubCategory',
	async (data) => {
		const response = await httpService.get(`productService/category`, {
			params: data
		});
		return response.data;
	}
);
export const deleteCategoryData: any = createAsyncThunk<any>(
	'deleteCategory',
	async (data) => {
		const response = await httpService.delete(`productService/category`, {
			data
		});
		return response.data;
	}
);
export const getCategoryDetails: any = createAsyncThunk<any>(
	'getCategoryDetails',
	async (data) => {
		const response = await httpService.get(
			`productService/category/get-category`,
			{
				params: data
			}
		);
		return response.data.data;
	}
);
export const addCategory: any = createAsyncThunk<any>(
	'addCategory',
	async (data: any, { rejectWithValue }: any) => {
		const newData = { ...data };
		delete newData.id;
		try {
			const response: any = await httpService.post(
				`productService/category`,
				newData
				//,
				// {
				//     headers: {
				//         userId: data.id
				//     }
				// }
			);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);
export const editCategory: any = createAsyncThunk<any>(
	'editCategory',
	async (data: any, { rejectWithValue }: any) => {
		const newData = { ...data };
		delete newData.id;
		try {
			const response: any = await httpService.post(
				`productService/category`,
				newData
				//,
				// {
				//     headers: {
				//         userId: data.id
				//     }
				// }
			);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);
export const changeOrderOfCategory: any = createAsyncThunk<any>(
	'changeOrderOfCategory',
	async (data: any, { rejectWithValue }: any) => {
		try {
			const response: any = await httpService.put(
				`productService/category`,
				data
			);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response);
		}
	}
);
export const getProductofFamily: any = createAsyncThunk<any>(
	'getProductofFamily',
	async (data) => {
		const response = await httpService.get(
			`productService/category/allProductList`,
			{
				params: data
			}
		);
		return response.data;
	}
);
export const changeOrderOfProduct: any = createAsyncThunk<any>(
	'changeOrderOfProduct',
	async (data: any, { rejectWithValue }: any) => {
		try {
			const response: any = await httpService.post(
				`productService/category/categoryProductList`,
				data
			);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response);
		}
	}
);
export const getCategoryProductList: any = createAsyncThunk<any>(
	'getCategoryProductList',
	async (data) => {
		const response = await httpService.get(
			`productService/category/categoryProductList`,
			{
				params: data
			}
		);
		return response.data;
	}
);
